import Icon01 from './icon-1.png';
import Icon02 from './icon-2.png';
import Icon03 from './icon-3.png';
import Icon04 from './icon-4.png';
import Icon06 from './icon-6.png';
import Icon07 from './icon-7.png';
import Icon08 from './icon-8.png';
import Icon09 from './icon-9.png';
import Icon10 from './icon-10.png';
import Icon11 from './icon-11.png';
import Icon12 from './icon-12.png';
import Icon13 from './icon-13.png';
import RomanceAlchemistsIcon from './romance-alchemists.png';
import ThrillerArchitectsIcon from './thriller-architects.png';
import BiographyIcon from './biography-historians.png';
import SelfHelpIcon from './self-help-guides.png';
import MysteryEngineersIcon from './mystery-engineers.png';
import ScifiInnovatorsIcon from './sci-fi-innovators.png';

export {Icon01, Icon02, Icon03, Icon04, Icon06, Icon07, Icon08, Icon09, Icon10, Icon11, Icon12, Icon13, RomanceAlchemistsIcon, ThrillerArchitectsIcon, BiographyIcon, SelfHelpIcon, MysteryEngineersIcon, ScifiInnovatorsIcon};
